import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TableContainer, Table, TableBody, TableCell, TableHead, TableRow, List, ListItem, ListItemText, Checkbox, ListItemSecondaryAction, CircularProgress, Grid, TextField, Tooltip } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import { globalGetService, globalPutService } from '../../../utils/globalApiServices';
import { checkApiStatus, getLocalStorageInfo } from '../../../utils';
import { CustomChip, PageLoader } from '../../../shared_elements';
import { assetType } from '../../../constants';

const AssignUser = ({ item, assetData, assignUserData, toggleModalFn, getResponseBack, pageTitle }) => {
    const [initialUsers, setInitialUsers] = useState([])
    const [searchTerm, setSearchTerm] = useState('');
    const { enqueueSnackbar } = useSnackbar();
    const [pageLoader, setPageLoader] = useState()
    const [filteredUsers, setFilteredUsers] = useState(initialUsers);
    const [selectedUsers, setSelectedUsers] = useState({});
    const userInfo = getLocalStorageInfo()
    useEffect(() => {
        setPageLoader(true)
        globalGetService(`/maintenance/${pageTitle==="Shopvisit" ? "shop_visit" :"claim"}/user-dropdown/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    // const updatedData = response?.data?.data?.filter(currentUser =>
                    //     !item?.forward_users?.includes(currentUser?.id))
                    //     .map(user => ({
                    //         ...user,
                    //         isDisabled: item?.approver_users?.some(id => id === user?.id)
                    //     }));
                    // const selectedIds = new Set(item?.approver_users?.map(user => user.id));
                    // const updatedAllUsers = response?.data?.data.map(user => ({
                    //     ...user,
                    //     isDisabled: selectedIds.has(user.id)
                    // }));
                    setPageLoader(false)
                    const targetId = userInfo?.user?.id;
                    if(response?.data?.data?.length>0){
                        const reorderedUsers = [
                            ...response?.data?.data?.filter(user => user.id === targetId),
                            ...response?.data?.data?.filter(user => user.id !== targetId)   
                        ];
                        setInitialUsers(reorderedUsers)
                    }
                }
            })
    }, [])
    useEffect(() => {
        const newFilteredUsers = initialUsers.filter(user =>
            user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            user.email.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredUsers(newFilteredUsers);
    }, [searchTerm, initialUsers]);

    console.log('initialuser',initialUsers,userInfo?.user?.id);

    const handleSearchInputChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleCheckboxChange = (userId, isChecked) => {
        setSelectedUsers(prevSelectedUsers => ({
            ...prevSelectedUsers,
            [userId]: isChecked,
        }));
    };
   
    const selectedUserIds = selectedUsers && Object.keys(selectedUsers).filter((userId) => selectedUsers[Number(userId)]).map(Number);
    const previousUserIds = item?.approver_users?.filter((userId) => Number(userId?.id ? userId?.id : userId)) || []
    const checkedUsers = initialUsers?.filter(user =>selectedUserIds && selectedUserIds.includes(user?.id));
    const assignUserFn = () => {
        let updatedUrl
        if (assignUserData?.moduleName === "claims") {
            updatedUrl = `/maintenance/${assetType[assetData?.asset_type]}/asset/${assetData?.asset_slug}/claims/${item.id}/send-for-approval/`
        } else {
            updatedUrl = `/maintenance/asset-type/${assetType[assetData?.asset_type]}/asset/${assetData?.asset_slug}/shopvisit/${item.id}/${item?.status?.value == 5 || item?.status?.value == 7 ? "send-for-shop-visit-approval" : "send-for-approval"}/`
        }
        let updatedPayload
        if(item?.status?.value == 5 ){
            updatedPayload = selectedUserIds
        }else  updatedPayload = [...selectedUserIds,...previousUserIds]
        globalPutService(updatedUrl, { approver_users: updatedPayload })
            .then(response => {
                if (checkApiStatus(response)) {
                    toggleModalFn()
                    getResponseBack()
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                }
            })
    }
    return (
        <>
            {pageLoader ? <PageLoader /> :
                <Dialog
                    open={assignUserData?.modal}
                    onClose={toggleModalFn}
                    aria-labelledby="scroll-dialog-title"
                    maxWidth="xs"
                    fullWidth
                    className="verify-amount-modal assign-user-modal"
                >
                    <DialogTitle id="scroll-dialog-title">{`Assign User(s)`} </DialogTitle>
                    <DialogContent dividers={true} style={{ maxHeight: "402px", height: "500px", overflowY: "none" }}>
                        <TableContainer style={{ maxHeight: "400px", overflowY: "auto", scrollbarWidth: "none", }}>
                            <div className='search-section'>
                                <Grid item xs={12} >
                                    <TextField
                                        label="Search User"
                                        fullWidth
                                        margin="normal"
                                        value={searchTerm}
                                        InputLabelProps={{ shrink: true }}
                                        onChange={handleSearchInputChange}
                                        variant='outlined'
                                        placeholder='Search by name..'
                                    />
                                </Grid>
                                </div>
                                {checkedUsers?.length>0 ? <Grid className='check-user'> <Grid xs={11} >
                                    {checkedUsers?.map(ele=>{
                                    return( <CustomChip  title={ele?.name} label={ele?.name}/>)
                                })}</Grid><Grid xs={1} style={{display:"flex" ,justifyContent:"end",cursor:"pointer",position: "sticky",
                                    top: "0px"}}><Tooltip title="Clear All"><CancelIcon onClick={()=>{ setSelectedUsers([]);setSearchTerm("")}} align="left" color='primary' /></Tooltip>
                                </Grid></Grid>:null }
                            <Table stickyHeader  size="small">
                                <TableHead >
                                    <TableRow>
                                        <TableCell style={{top : checkedUsers?.length>0 ? "147px" : "72px"}}>User(s)</TableCell>
                                        <TableCell style={{top : checkedUsers?.length>0 ? "147px" : "72px"}}>Email</TableCell>
                                        <TableCell style={{top : checkedUsers?.length>0 ? "147px" : "72px"}} align="right">Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredUsers?.length && !pageLoader ? (
                                        filteredUsers.map((item, index) => (
                                            <TableRow key={index} hover>
                                                <TableCell style={{ position: "sticky",top : checkedUsers?.length>0 ? "130px" : "72px"}}>{item?.name || ''} </TableCell>
                                                <TableCell style={{position: "sticky",top : checkedUsers?.length>0 ? "130px" : "72px"}}>{item?.email || ''} </TableCell>
                                                <TableCell style={{position: "sticky",top : checkedUsers?.length>0 ? "130px" : "72px"}} align="right">
                                                    <Checkbox
                                                        color="primary"
                                                        checked={selectedUsers[item.id] || false}
                                                        onChange={(event) => handleCheckboxChange(item.id, event.target.checked)}
                                                        disabled={item?.isDisabled}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={3} align="center">
                                                No User(s) Found
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>

                    </DialogContent>
                    <DialogActions>
                        <div>
                            <div style={{ float: 'right' }}>
                                <Button onClick={toggleModalFn} color="primary" variant='outlined' className='mr-5' size="small">Cancel</Button>
                                {selectedUserIds?.length>0 ?
                                    <Button disabled={pageLoader ? true : filteredUsers?.length ? false : true} variant="contained" onClick={assignUserFn} color="primary" size="small">
                                        {pageLoader ? <CircularProgress color="#ffffff" size={24} /> : (item?.status?.value == 1 ||item?.status?.value == 2) && pageTitle == "Shopvisit" ? "Send For Review" : 'Send For Approval'}
                                    </Button>
                                    : null}
                            </div>
                        </div>
                    </DialogActions>
                </Dialog>}
        </>
    )
}
export default AssignUser;
